const DriveYT = () => {
    // Add your component's JSX code here
    return (
        <div>
            <h1>DriveYT</h1>
        </div>
    );
}

export default DriveYT;
